<template>
	<div v-if="loading" class="flex justify-center">
		<svg
			class="animate-spin mt-10 h-10 w-10 text-white"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
			viewBox="0 0 24 24"
		>
			<circle
				class="opacity-25"
				cx="12"
				cy="12"
				r="10"
				stroke="currentColor"
				stroke-width="4"
				style="--darkreader-inline-stroke: currentColor"
				data-darkreader-inline-stroke=""
			></circle>
			<path
				class="opacity-75"
				fill="currentColor"
				d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
				style="--darkreader-inline-fill: currentColor"
				data-darkreader-inline-fill=""
			></path>
		</svg>
	</div>
</template>

<script>
export default {
	props: {
		loading: {
			type: Boolean,
			required: true,
		},
	},
};
</script>

<style></style>
